import React from 'react';
import img1 from '../../../assets/itcourse/Screenshot 2022-12-11 161337.png'
import img2 from '../../../assets/itcourse/Screenshot 2022-12-11 161412.png'
import img3 from '../../../assets/itcourse/Screenshot 2022-12-11 161433.png'
import './itcourse.css'

const Itcourse = () => {
    return (
        <div className='mx-0 mt-8 lg:mt-10 lg:mx-10'>
            <h1 className='mb-4 text-xl font-semibold'>Expert Technology</h1>
            <div>
                <p className='mb-4 text-slate-800'>Here some demo image</p>
                <div className='grid grid-cols-1 gap-5 lg:grid-cols-3'>
                    <div className='border rounded-lg shadow-lg shadow-slate-300'>
                        <img src={img1} alt="" />
                    </div>
                    <div className='border rounded-lg shadow-lg shadow-slate-300'>
                        <img src={img2} alt="" />
                    </div>
                    <div className='border rounded-lg shadow-lg shadow-slate-300'>
                        <img src={img3} alt="" />
                    </div>
                </div>
                <div className='mt-5 features'>
                    <h1 className='text-xl font-semibold'>Features:</h1>
                    <p>•Authentication system(google,email-password)</p>
                    <p>•Fully Responsive(mobile)</p>
                    <p>•PDF download system</p>
                    <p>•Success message by toast</p>
                    <p>•Use server side and database(express js,mongodb)</p>

                </div>
                <div className='mt-5 links'>
                    <a href="it-course-3714d.web.app" className='mr-4 underline' rel="noreferrer" target="_blank">Live demo</a>
                    <a href="https://github.com/Maruf-Stack/learning-platform-client" rel="noreferrer" target="_blank" className='mr-4 underline'>Github client side</a>
                    <a href="https://github.com/Maruf-Stack/learning-platform-server" rel="noreferrer" target="_blank" className='underline'>Github server side</a>
                </div>
            </div>

        </div>
    );
};

export default Itcourse;